/**
 * Hosts the dashboard Worker answers on: log.monoblock.ae (MonoLog) and ping.monoblock.ae (Ping,
 * the notification inbox on its own: README, "Ping"). Any "ping." host counts as Ping, so
 * local and test setups (ping.localhost, ping.test) behave the same.
 */
export const PING_HOST = "ping.monoblock.ae";
export const PING_ORIGIN = `https://${PING_HOST}`;

export const isPingHost = (hostname: string) => hostname === PING_HOST || hostname.startsWith("ping.");

/** Where senders post notifications, as shown in Settings → Ping's snippets. */
export function notifyEndpoint(url: URL): string {
  if (isPingHost(url.hostname)) return `${url.origin}/v1/notify`;
  if (url.hostname === "monoblock.ae" || url.hostname.endsWith(".monoblock.ae")) return `${PING_ORIGIN}/v1/notify`;
  return `${url.origin}/api/v1/notify`;
}
